import React from "react";

type CarpetType = "solid" | "fade-light" | "fade-dark" | "fade-light-to-dark";

interface CarpetProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: CarpetType;
  children?: React.ReactNode;
}

const Carpet: React.FC<CarpetProps> = ({ type = "solid", children, className = "", ...props }) => {
  const typeClasses: Record<CarpetType, string> = {
    solid: "carpet--solid",
    "fade-light": "carpet--fade-light",
    "fade-dark": "carpet--fade-dark",
    "fade-light-to-dark": "carpet--fade-light-to-dark",
  };

  const typeClass = typeClasses[type];
  const combinedClasses = `carpet ${typeClass} ${className}`.trim();

  return (
    <div className={combinedClasses} {...props}>
      {children}
    </div>
  );
};

export default Carpet;
